// Login
export const LOGIN_PAGE_SHOW_LOGIN_FORM = 'LOGIN_PAGE_SHOW_LOGIN_FORM';
export const RESET_LOGIN_PAGE = 'RESET_LOGIN_PAGE';
export const UPDATE_LOGIN_PAGE_FORM_FIELD = 'UPDATE_LOGIN_PAGE_FORM_FIELD';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

// Drawer
export const UPDATE_DRAWER_FIELD = 'UPDATE_DRAWER_FIELD';

// Halls
export const GET_CRF_REQUEST = 'GET_CRF_REQUEST';
export const GET_CRF_SUCCESS = 'GET_CRF_SUCCESS';
export const GET_CRF_ERROR = 'GET_CRF_ERROR';


// Equipment Page
export const GET_EQUIPMENT_PAGE_REQUEST = 'GET_EQUIPMENT_PAGE_REQUEST';
export const GET_EQUIPMENT_PAGE_SUCCESS = 'GET_EQUIPMENT_PAGE_SUCCESS';
export const GET_EQUIPMENT_PAGE_ERROR = 'GET_EQUIPMENT_PAGE_ERROR';
export const RESET_EQUIPMENT_PAGE_META = 'RESET_EQUIPMENT_PAGE_META';
export const RESET_EQUIPMENT_PAGE = 'RESET_EQUIPMENT_PAGE';

export const SUBMIT_EQUIPMENT_BASIC_PAGE_REQUEST = 'SUBMIT_EQUIPMENT_BASIC_PAGE_REQUEST';
export const SUBMIT_EQUIPMENT_BASIC_PAGE_SUCCESS = 'SUBMIT_EQUIPMENT_BASIC_PAGE_SUCCESS';
export const SUBMIT_EQUIPMENT_BASIC_PAGE_ERROR = 'SUBMIT_EQUIPMENT_BASIC_PAGE_ERROR';

export const GET_EQUIPMENT_BASIC_PAGE_REQUEST = 'GET_EQUIPMENT_BASIC_PAGE_REQUEST';
export const GET_EQUIPMENT_BASIC_PAGE_SUCCESS = 'GET_EQUIPMENT_BASIC_PAGE_SUCCESS';
export const GET_EQUIPMENT_BASIC_PAGE_ERROR = 'GET_EQUIPMENT_BASIC_PAGE_ERROR';

export const DELETE_EQUIPMENT_BASIC_PAGE_REQUEST = 'DELETE_EQUIPMENT_BASIC_PAGE_REQUEST';
export const DELETE_EQUIPMENT_BASIC_PAGE_SUCCESS = 'DELETE_EQUIPMENT_BASIC_PAGE_SUCCESS';
export const DELETE_EQUIPMENT_BASIC_PAGE_ERROR = 'DELETE_EQUIPMENT_BASIC_PAGE_ERROR';

export const RESET_EQUIPMENT_BASIC_PAGE_META = 'RESET_EQUIPMENT_BASIC_PAGE_META';
export const RESET_EQUIPMENT_BASIC_PAGE = 'RESET_EQUIPMENT_BASIC_PAGE';

// Equipment Usage History
export const GET_EQUIPMENT_USAGE_HISTORY_REQUEST = 'GET_EQUIPMENT_USAGE_HISTORY_REQUEST';
export const GET_EQUIPMENT_USAGE_HISTORY_SUCCESS = 'GET_EQUIPMENT_USAGE_HISTORY_SUCCESS';
export const GET_EQUIPMENT_USAGE_HISTORY_ERROR = 'GET_EQUIPMENT_USAGE_HISTORY_ERROR';
export const RESET_EQUIPMENT_USAGE_HISTORY_META = 'RESET_EQUIPMENT_USAGE_HISTORY_META';
export const RESET_EQUIPMENT_USAGE_HISTORY = 'RESET_EQUIPMENT_USAGE_HISTORY';

// Equipment Controller Status
export const TOGGLE_EQUIPMENT_CONTROLLER_REQUEST = 'TOGGLE_EQUIPMENT_CONTROLLER_REQUEST';
export const TOGGLE_EQUIPMENT_CONTROLLER_SUCCESS = 'TOGGLE_EQUIPMENT_CONTROLLER_SUCCESS';
export const TOGGLE_EQUIPMENT_CONTROLLER_ERROR = 'TOGGLE_EQUIPMENT_CONTROLLER_ERROR';

// Admin Page
export const GET_ADMIN_PAGE_REQUEST = 'GET_ADMIN_PAGE_REQUEST';
export const GET_ADMIN_PAGE_SUCCESS = 'GET_ADMIN_PAGE_SUCCESS';
export const GET_ADMIN_PAGE_ERROR = 'GET_ADMIN_PAGE_ERROR';
export const RESET_ADMIN_PAGE_META = 'RESET_ADMIN_PAGE_META';
export const RESET_ADMIN_PAGE = 'RESET_ADMIN_PAGE';
export const SUBMIT_ADMIN_NOTIFICATION_STATUS_REQUEST = 'SUBMIT_ADMIN_NOTIFICATION_STATUS_REQUEST';
export const SUBMIT_ADMIN_NOTIFICATION_STATUS_SUCCESS = 'SUBMIT_ADMIN_NOTIFICATION_STATUS_SUCCESS';
export const SUBMIT_ADMIN_NOTIFICATION_STATUS_ERROR = 'SUBMIT_ADMIN_NOTIFICATION_STATUS_ERROR';

// Admin Basic Page
export const GET_ADMIN_BASIC_PAGE_REQUEST = 'GET_ADMIN_BASIC_PAGE_REQUEST';
export const GET_ADMIN_BASIC_PAGE_SUCCESS = 'GET_ADMIN_BASIC_PAGE_SUCCESS';
export const GET_ADMIN_BASIC_PAGE_ERROR = 'GET_ADMIN_BASIC_PAGE_ERROR';
export const RESET_ADMIN_BASIC_PAGE_META = 'RESET_ADMIN_BASIC_PAGE_META';
export const RESET_ADMIN_BASIC_PAGE = 'RESET_ADMIN_BASIC_PAGE';

export const SUBMIT_ADMIN_BASIC_PAGE_REQUEST = 'SUBMIT_ADMIN_BASIC_PAGE_REQUEST';
export const SUBMIT_ADMIN_BASIC_PAGE_SUCCESS = 'SUBMIT_ADMIN_BASIC_PAGE_SUCCESS';
export const SUBMIT_ADMIN_BASIC_PAGE_ERROR = 'SUBMIT_ADMIN_BASIC_PAGE_ERROR';

export const VALIDATE_EMAIL_ERROR = 'VALIDATE_EMAIL_ERROR';
export const VALIDATE_EMAIL_SUCCESS = 'VALIDATE_EMAIL_SUCCESS';


//Location List Page

export const GET_LOCATION_PAGE_REQUEST ='GET_LOCATION_PAGE_REQUEST';
export const GET_LOCATION_PAGE_ERROR = 'GET_LOCATION_PAGE_ERROR';
export const GET_LOCATION_PAGE_SUCCESS = 'GET_LOCATION_PAGE_SUCCESS';

export const RESET_LOCATION_PAGE_META = 'RESET_LOCATION_PAGE_META';
export const RESET_LOCATION_PAGE = 'RESET_LOCATION_PAGE';

//Location Detail Page

export const SUBMIT_LOCATION_BASIC_PAGE_REQUEST = 'SUBMIT_LOCATION_BASIC_PAGE_REQUEST';
export const SUBMIT_LOCATION_BASIC_PAGE_SUCCESS = 'SUBMIT_LOCATION_BASIC_PAGE_SUCCESS';
export const SUBMIT_LOCATION_BASIC_PAGE_ERROR = 'SUBMIT_LOCATION_BASIC_PAGE_ERROR';

export const GET_LOCATION_BASIC_PAGE_REQUEST = 'GET_LOCATION_BASIC_PAGE_REQUEST';
export const GET_LOCATION_BASIC_PAGE_SUCCESS = 'GET_LOCATION_BASIC_PAGE_SUCCESS';
export const GET_LOCATION_BASIC_PAGE_ERROR = 'GET_LOCATION_BASIC_PAGE_ERROR';

export const DELETE_LOCATION_BASIC_PAGE_REQUEST = 'DELETE_LOCATION_BASIC_PAGE_REQUEST';
export const DELETE_LOCATION_BASIC_PAGE_SUCCESS = 'DELETE_LOCATION_BASIC_PAGE_SUCCESS';
export const DELETE_LOCATION_BASIC_PAGE_ERROR = 'DELETE_LOCATION_BASIC_PAGE_ERROR';

export const RESET_LOCATION_BASIC_PAGE_META = 'RESET_LOCATION_BASIC_PAGE_META';
export const RESET_LOCATION_BASIC_PAGE = 'RESET_LOCATION_BASIC_PAGE';

// API Key Management Page

export const GET_API_PAGE_REQUEST = 'GET_API_PAGE_REQUEST';
export const GET_API_PAGE_ERROR = 'GET_API_PAGE_ERROR';
export const GET_API_PAGE_SUCCESS = 'GET_API_PAGE_SUCCESS';
export const RESET_API_PAGE_META = 'RESET_API_PAGE_META';
export const RESET_API_PAGE = 'RESET_API_PAGE';

// API Key Management Detail Page
export const GET_API_DETAIL_PAGE_REQUEST = 'GET_API_DETAIL_PAGE_REQUEST';
export const GET_API_DETAIL_PAGE_ERROR = 'GET_API_DETAIL_PAGE_ERROR';
export const GET_API_DETAIL_PAGE_SUCCESS = 'GET_API_DETAIL_PAGE_SUCCESS';

export const SUBMIT_API_DETAIL_PAGE_REQUEST = 'SUBMIT_API_DETAIL_PAGE_REQUEST';
export const SUBMIT_API_DETAIL_PAGE_ERROR = 'SUBMIT_API_DETAIL_PAGE_ERROR';
export const SUBMIT_API_DETAIL_PAGE_SUCCESS = 'SUBMIT_API_DETAIL_PAGE_SUCCESS';

export const DELETE_API_DETAIL_PAGE_REQUEST = 'DELETE_API_DETAIL_PAGE_REQUEST';
export const DELETE_API_DETAIL_PAGE_ERROR = 'DELETE_API_DETAIL_PAGE_ERROR';
export const DELETE_API_DETAIL_PAGE_SUCCESS = 'DELETE_API_DETAIL_PAGE_SUCCESS';

export const RESET_API_DETAIL_PAGE_META = 'RESET_API_DETAIL_PAGE_META';
export const RESET_API_DETAIL_PAGE = 'RESET_API_DETAIL_PAGE';

//REPORTS

export const DOWNLOAD_EQUIPMENT_REPORTS_REQUEST = 'DOWNLOAD_EQUIPMENT_REPORTS_REQUEST';
export const DOWNLOAD_EQUIPMENT_REPORTS_ERROR = 'DOWNLOAD_EQUIPMENT_REPORTS_ERROR';
export const DOWNLOAD_EQUIPMENT_REPORTS_SUCCESS = 'DOWNLOAD_EQUIPMENT_REPORTS_SUCCESS';

export const RESET_DONWLOAD_REPORTS_META = 'RESET_DONWLOAD_REPORTS_META';
export const RESET_DOWNLOAD_REPORTS_PAGE = 'RESET_DOWNLOAD_REPORTS_PAGE';

